export enum HomeHealthRacesEnum {
    White = "0",
    BlackOrAfricanAmerican = "1",
    AmericanIndianorAlaskaNative = "2",
    AsianIndian = "3",
    Chinese = "4",
    Filipino = "5",
    Japanese = "6",
    Korean = "7",
    Vietnamese = "8",
    OtherAsian = "9",
    NativeHawaiian = "10",
    GuamanianOrChamorro = "11",
    Samoan = "12",
    OtherPacificIslander = "13",
    PatientUnableToRespond = "14",
    PatientDeclinesToRespond = "15",
    NoneOfTheAbove = "16"
}

export enum HomeHealthEthnicityEnum {
    NoNotOfHispanicOrigin = "0",
    MexicanAmericanChicano = "1",
    Puerto = "2",
    Cuban = "3",
    AnotherHispanicLatinoOrSpanishOrigin = "4",
    PatientUnableToRespond = "5",
    PatientDeclinesToRespond = "6"
}
